export enum ItemTypeEnum {
    DOCUMENT = 'DOCUMENT',
    MATTER = 'MATTER',
    FOLDER = 'FOLDER',
    EMAIL = 'EMAIL',
    TAB = 'TAB'
  }
  